import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/bridge-environment-design/components/BridgeContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/bridge-environment-design/components/BridgeHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/JourneyNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/NextBridgeCTA.tsx");
